// import { useState, useEffect, useContext } from "react";


// const Dashboard = () => {
//   const [images, setImages] = useState([]);
//   const [dragActive, setDragActive] = useState(false);
//   const [savedItems, setSavedItems] = useState([]);

//   // Fetch saved jewelry items on component mount



//   useEffect(() => {
//     fetchSavedItems();
//   }, []);

//   const fetchSavedItems = async () => {
//     try {
//       // const response = await fetch("https://jobeads-4d6054ae0133.herokuapp.com/api/jewelry");
//       // const data = await response.json();
//       // setSavedItems(data);
//     } catch (error) {
//       console.error("Error fetching saved items:", error);
//     }
//   };

//   const handleDrag = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (e.type === "dragenter" || e.type === "dragover") {
//       setDragActive(true);
//     } else if (e.type === "dragleave") {
//       setDragActive(false);
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//       handleFiles(e.dataTransfer.files);
//     }
//   };

//   const handleChange = (e) => {
//     e.preventDefault();
//     if (e.target.files && e.target.files[0]) {
//       handleFiles(e.target.files);
//     }
//   };

//   const handleFiles = (files) => {
//     const newImages = Array.from(files)
//       .filter((file) => file.type.startsWith("image/"))
//       .map((file) => ({
//         id: Math.random().toString(36).substr(2, 9),
//         file,
//         preview: URL.createObjectURL(file),
//         description: "",
//         cat: "Select Category",
//         sku: "",
//       }));
//     setImages((prev) => [...prev, ...newImages]);
//   };

//   const updateImageDetails = (id, field, value) => {
//     setImages((prev) =>
//       prev.map((img) => (img.id === id ? { ...img, [field]: value } : img))
//     );
//   };

//   const removeImage = (id) => {
//     setImages((prev) => prev.filter((img) => img.id !== id));
//   };

//   const uploadImages = async () => {
//     const formData = new FormData();
//     const details = images.map(({ description, cat, sku }) => ({
//       description,
//       cat,
//       sku,
//     }));

//     images.forEach((image) => {
//       formData.append("images", image.file);
//     });
//     formData.append("details", JSON.stringify(details));

//     try {
     
//       //const response = await fetch("https://jobeads-4d6054ae0133.herokuapp.com/api/upload", {
//        const response = await fetch("http://localhost:5003/api/upload", {
//         method: "POST",
//         body: formData,
//       });
//       const result = await response.json();
//       if (response.ok) {
//         alert("Photos and details uploaded successfully!");
//         setImages([]); // Clear images after successful upload
//         fetchSavedItems(); // Refresh saved items
//       } else {
//         alert("Upload failed: " + result.message);
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       alert("Upload failed: Server error");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
//         <h1 className="text-2xl font-bold text-gray-800 mb-4">Upload Jewelry Stuff</h1>
//         <div
//           className={`border-2 border-dashed rounded-lg p-6 mb-6 text-center ${
//             dragActive ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-gray-50"
//           }`}
//           onDragEnter={handleDrag}
//           onDragLeave={handleDrag}
//           onDragOver={handleDrag}
//           onDrop={handleDrop}
//         >
//           <p className="text-gray-600 mb-2">Drag and drop your jewelry photos here, or</p>
//           <label
//             htmlFor="file-upload"
//             className="cursor-pointer bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//           >
//             Select Photos
//           </label>
//           <input
//             id="file-upload"
//             type="file"
//             accept="image/*"
//             multiple
//             className="hidden"
//             onChange={handleChange}
//           />
//         </div>
//         {images.length > 0 && (
//           <div>
//             <h2 className="text-lg font-semibold text-gray-700 mb-4">Pending Uploads</h2>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//               {images.map((image) => (
//                 <div key={image.id} className="relative group bg-gray-50 p-4 rounded-lg shadow">
//                   <img
//                     src={image.preview}
//                     alt="Jewelry preview"
//                     className="w-full h-48 object-cover rounded-lg mb-4"
//                   />
//                   <div className="space-y-2">
//                     <textarea
//                       placeholder="Description (e.g., Elegant diamond necklace)"
//                       value={image.description}
//                       onChange={(e) =>
//                         updateImageDetails(image.id, "description", e.target.value)
//                       }
//                       className="w-full p-2 border rounded text-sm"
//                       rows="3"
//                     />
//                     <select
//                       value={image.cat}
//                       onChange={(e) => updateImageDetails(image.id, "cat", e.target.value)}
//                       className="w-full p-2 border rounded text-sm"
//                     >
//                       <option disabled>Select Category</option>
//                       <option value="Bracelets">Bracelets</option>
//                       <option value="Necklaces">Necklaces</option>
//                       <option value="Earrings">Earrings</option>
//                       <option value="Collars">Collars</option>
//                       <option value="Other">Other</option>
//                     </select>
//                     <input
//                       type="text"
//                       placeholder="SKU"
//                       value={image.sku}
//                       onChange={(e) => updateImageDetails(image.id, "sku", e.target.value)}
//                       className="w-full p-2 border rounded text-sm"
//                     />
//                   </div>
//                   <button
//                     onClick={() => removeImage(image.id)}
//                     className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
//                   >
//                     X
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         {images.length > 0 && (
//           <button
//             className="mt-6 bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600"
//             onClick={uploadImages}
//           >
//             Upload All
//           </button>
//         )}
//         {savedItems.length > 0 && (
//           <div className="mt-8">
//             <h2 className="text-lg font-semibold text-gray-700 mb-4">Saved Jewelry Items</h2>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//               {savedItems.map((item) => (
//                 <div key={item._id} className="bg-gray-50 p-4 rounded-lg shadow">
//                   <img
//                     src={item.imagePath}
//                     alt={item.description || "Jewelry"}
//                     className="w-full h-48 object-cover rounded-lg mb-4"
//                   />
//                   <p className="text-sm text-gray-600">Description: {item.description || "N/A"}</p>
//                   <p className="text-sm text-gray-600">Category: {item.category || "N/A"}</p>
//                   <p className="text-sm text-gray-600">SKU: {item.sku || "N/A"}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


// import { useState, useEffect } from "react";

// const Dashboard = () => {
//   const [images, setImages] = useState([]);
//   const [dragActive, setDragActive] = useState(false);
//   const [savedItems, setSavedItems] = useState([]);

//   // Fetch saved items when component mounts
//   useEffect(() => {
//     fetchSavedItems();
//   }, []);

//   const fetchSavedItems = async () => {
//     try {
//       const response = await fetch("http://localhost:5003/api/jewelry");
//       // const response = await fetch("https://jobeads-4d6054ae0133.herokuapp.com/api/jewelry");
//       if (response.ok) {
//         const data = await response.json();
//         setSavedItems(data);
//       }
//     } catch (error) {
//       console.error("Error fetching saved items:", error);
//     }
//   };

//   const handleDrag = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (e.type === "dragenter" || e.type === "dragover") {
//       setDragActive(true);
//     } else if (e.type === "dragleave") {
//       setDragActive(false);
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//       handleFiles(e.dataTransfer.files);
//     }
//   };

//   const handleChange = (e) => {
//     e.preventDefault();
//     if (e.target.files && e.target.files[0]) {
//       handleFiles(e.target.files);
//     }
//   };

//   const handleFiles = (files) => {
//     const newImages = Array.from(files)
//       .filter((file) => file.type.startsWith("image/"))
//       .map((file) => ({
//         id: Math.random().toString(36).substr(2, 9),
//         file,
//         preview: URL.createObjectURL(file),
//         name: "",
//         price: "",
//         description: "",
//         cat: "Select Category",
//         sku: "",
//       }));
//     setImages((prev) => [...prev, ...newImages]);
//   };

//   const updateImageDetails = (id, field, value) => {
//     setImages((prev) =>
//       prev.map((img) => (img.id === id ? { ...img, [field]: value } : img))
//     );
//   };

//   const removeImage = (id) => {
//     setImages((prev) => prev.filter((img) => img.id !== id));
//   };

//   const uploadImages = async () => {
//     if (images.length === 0) return;

//     const formData = new FormData();

//     const details = images.map(({ name, price, description, cat, sku }) => ({
//       name: name.trim(),
//       price: parseFloat(price) || 0,
//       description: description.trim(),
//       cat: cat === "Select Category" ? "" : cat,
//       sku: sku.trim(),
//     }));

//     images.forEach((image) => {
//       formData.append("images", image.file);
//     });
//     formData.append("details", JSON.stringify(details));

//     try {
//       const response = await fetch("http://localhost:5003/api/upload", {
//         method: "POST",
//         body: formData,
//       });

//       const result = await response.json();

//       if (response.ok) {
//         alert("All items uploaded successfully!");
//         setImages([]);
//         fetchSavedItems();
//       } else {
//         alert("Upload failed: " + (result.message || "Unknown error"));
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       alert("Upload failed – check server connection");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="bg-white rounded-2xl shadow-xl p-8 mb-10">
//           <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
//             Upload Jewelry Items
//           </h1>

//           {/* Drag & Drop Zone */}
//           <div
//             className={`border-4 border-dashed rounded-2xl p-16 text-center transition-all ${
//               dragActive ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-gray-50"
//             }`}
//             onDragEnter={handleDrag}
//             onDragLeave={handleDrag}
//             onDragOver={handleDrag}
//             onDrop={handleDrop}
//           >
//             <p className="text-xl text-gray-600 mb-6">
//               Drag & drop jewelry photos here, or
//             </p>
//             <label
//               htmlFor="file-upload"
//               className="cursor-pointer inline-block bg-blue-600 text-white px-10 py-4 rounded-xl text-lg font-medium hover:bg-blue-700 transition"
//             >
//               Choose Photos
//             </label>
//             <input
//               id="file-upload"
//               type="file"
//               accept="image/*"
//               multiple
//               className="hidden"
//               onChange={handleChange}
//             />
//           </div>

//           {/* Pending Uploads */}
//           {images.length > 0 && (
//             <div className="mt-12">
//               <h2 className="text-2xl font-bold text-gray-800 mb-6">
//                 Ready to Upload ({images.length} items)
//               </h2>

//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {images.map((image) => (
//                   <div
//                     key={image.id}
//                     className="relative bg-white border-2 border-gray-200 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition group"
//                   >
//                     <img
//                       src={image.preview}
//                       alt="Preview"
//                       className="w-full h-64 object-cover"
//                     />

//                     <div className="p-6 space-y-4">
//                       {/* Name */}
//                       <input
//                         type="text"
//                         placeholder="Item Name *"
//                         value={image.name}
//                         onChange={(e) =>
//                           updateImageDetails(image.id, "name", e.target.value)
//                         }
//                         className="w-full px-4 py-3 border rounded-lg text-lg font-semibold focus:ring-4 focus:ring-blue-300 focus:border-blue-500 outline-none"
//                         required
//                       />

//                       {/* Price */}
//                       <input
//                         type="number"
//                         placeholder="Price ($)"
//                         value={image.price}
//                         onChange={(e) =>
//                           updateImageDetails(image.id, "price", e.target.value)
//                         }
//                         className="w-full px-4 py-3 border rounded-lg text-lg focus:ring-4 focus:ring-green-300 focus:border-green-500 outline-none"
//                         step="0.01"
//                         min="0"
//                       />

//                       {/* Description */}
//                       <textarea
//                         placeholder="Description (optional)"
//                         value={image.description}
//                         onChange={(e) =>
//                           updateImageDetails(image.id, "description", e.target.value)
//                         }
//                         className="w-full px-4 py-3 border rounded-lg resize-none"
//                         rows="2"
//                       />

//                       {/* Category */}
//                       <select
//                         value={image.cat}
//                         onChange={(e) =>
//                           updateImageDetails(image.id, "cat", e.target.value)
//                         }
//                         className="w-full px-4 py-3 border rounded-lg"
//                       >
//                         <option value="Select Category" disabled>
//                           Select Category
//                         </option>
//                         <option>Bracelets</option>
//                         <option>Necklaces</option>
//                         <option>Earrings</option>
//                         <option>Mens</option>
//                         <option>Anklets</option>
//                         <option>Custom</option>
//                       </select>

//                       {/* SKU */}
//                       <input
//                         type="text"
//                         placeholder="SKU (optional)"
//                         value={image.sku}
//                         onChange={(e) =>
//                           updateImageDetails(image.id, "sku", e.target.value)
//                         }
//                         className="w-full px-4 py-3 border rounded-lg"
//                       />
//                     </div>

//                     <button
//                       onClick={() => removeImage(image.id)}
//                       className="absolute top-4 right-4 bg-red-600 text-white w-10 h-10 rounded-full flex items-center justify-center text-2xl font-bold opacity-0 group-hover:opacity-100 transition"
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>

//               <div className="mt-12 text-center">
//                 <button
//                   onClick={uploadImages}
//                   className="bg-green-600 text-white px-12 py-5 rounded-xl text-xl font-bold hover:bg-green-700 transition shadow-xl"
//                 >
//                   Upload All Items
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Saved / Uploaded Items */}
//         {savedItems.length > 0 && (
//           <div className="bg-white rounded-2xl shadow-xl p-8">
//             <h2 className="text-2xl font-bold text-gray-800 mb-8 text-center">
//               Your Jewelry Collection
//             </h2>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
//               {savedItems.map((item) => (
//                 <div
//                   key={item._id}
//                   className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition transform hover:-translate-y-2"
//                 >
//                   <img
//                     src={item.imagePath}
//                     alt={item.name || "Jewelry"}
//                     className="w-full h-64 object-cover"
//                   />
//                   <div className="p-6">
//                     <h3 className="font-bold text-xl text-gray-800 truncate">
//                       {item.name || "Unnamed Item"}
//                     </h3>
//                     <p className="text-3xl font-bold text-green-600 mt-2">
//                       ${parseFloat(item.price || 0).toFixed(2)}
//                     </p>
//                     <p className="text-gray-600 mt-3 text-sm">
//                       {item.description || "No description"}
//                     </p>
//                     <div className="mt-4 text-xs text-gray-500 space-y-1">
//                       <p>Category: {item.category || "N/A"}</p>
//                       <p>SKU: {item.sku || "N/A"}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;






import { useState, useEffect } from "react";

const Dashboard = () => {
  const [images, setImages] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const [savedItems, setSavedItems] = useState([]);

  useEffect(() => {
    fetchSavedItems();
  }, []);

  const fetchSavedItems = async () => {
    try {
                          
      const response = await fetch("https://jobeads-4d6054ae0133.herokuapp.com/api/jewelry");
     // const response = await fetch("http://localhost:5003/api/jewelry");
      if (response.ok) {
        const data = await response.json();
        setSavedItems(data);
      }
    } catch (error) {
      console.error("Error fetching saved items:", error);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFiles(e.target.files);
    }
  };

  const handleFiles = (files) => {
    const newImages = Array.from(files)
      .filter((file) => file.type.startsWith("image/"))
      .map((file) => ({
        id: Math.random().toString(36).substr(2, 9),
        file,
        preview: URL.createObjectURL(file),
        name: "",
        price: "",
        description: "",
        cat: "Select Category",
        sku: "",
      }));
    setImages((prev) => [...prev, ...newImages]);
  };

  const updateImageDetails = (id, field, value) => {
    setImages((prev) =>
      prev.map((img) => (img.id === id ? { ...img, [field]: value } : img))
    );
  };

  const removeImage = (id) => {
    setImages((prev) => prev.filter((img) => img.id !== id));
  };

  const uploadImages = async () => {
    if (images.length === 0) return;

    const formData = new FormData();

    const details = images.map(({ name, price, description, cat, sku }) => ({
      name: name.trim(),
      price: parseFloat(price) || 0,
      description: description.trim(),
      cat: cat === "Select Category" ? "" : cat,
      sku: sku.trim(),
    }));

    images.forEach((image) => {
      formData.append("images", image.file);
    });
    formData.append("details", JSON.stringify(details));

    try {
const response = await fetch("https://jobeads-4d6054ae0133.herokuapp.com/api/upload", {
     // const response = await fetch("http://localhost:5003/api/upload", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("All items uploaded successfully!");
        setImages([]);
      // fetchSavedItems();
      } else {
        alert("Upload failed: " + (result.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload failed – check server connection");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            Upload Jewelry Items
          </h1>

          {/* Drag & Drop Zone - Smaller */}
          <div
            className={`border-4 border-dashed rounded-xl p-10 text-center transition-all ${
              dragActive ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-gray-50"
            }`}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
          >
            <p className="text-lg text-gray-600 mb-4">
              Drag & drop photos here, or
            </p>
            <label
              htmlFor="file-upload"
              className="cursor-pointer inline-block bg-blue-600 text-white px-8 py-3 rounded-lg text-base font-medium hover:bg-blue-700 transition"
            >
              Choose Photos
            </label>
            <input
              id="file-upload"
              type="file"
              accept="image/*"
              multiple
              className="hidden"
              onChange={handleChange}
            />
          </div>

          {/* Pending Uploads - Compact Cards */}
          {images.length > 0 && (
            <div className="mt-8">
              <h2 className="text-xl font-bold text-gray-800 mb-5 text-center">
                Ready to Upload ({images.length} items)
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {images.map((image) => (
                  <div
                    key={image.id}
                    className="relative bg-white border border-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition group"
                  >
                    <img
                      src={image.preview}
                      alt="Preview"
                      className="w-full h-48 object-cover"
                    />

                    <div className="p-4 space-y-3">
                      <input
                        type="text"
                        placeholder="Item Name *"
                        value={image.name}
                        onChange={(e) =>
                          updateImageDetails(image.id, "name", e.target.value)
                        }
                        className="w-full px-3 py-2 border rounded text-sm font-medium focus:ring-2 focus:ring-blue-300 outline-none"
                      />

                      <input
                        type="number"
                        placeholder="Price ($)"
                        value={image.price}
                        onChange={(e) =>
                          updateImageDetails(image.id, "price", e.target.value)
                        }
                        className="w-full px-3 py-2 border rounded text-sm focus:ring-2 focus:ring-green-300 outline-none"
                        step="0.01"
                        min="0"
                      />

                      <textarea
                        placeholder="Description"
                        value={image.description}
                        onChange={(e) =>
                          updateImageDetails(image.id, "description", e.target.value)
                        }
                        className="w-full px-3 py-2 border rounded text-sm resize-none"
                        rows="2"
                      />

                      <select
                        value={image.cat}
                        onChange={(e) =>
                          updateImageDetails(image.id, "cat", e.target.value)
                        }
                        className="w-full px-3 py-2 border rounded text-sm"
                      >
                        <option value="Select Category" disabled>Select Category</option>
                        <option>Bracelets</option>
                        <option>Necklaces</option>
                        <option>Earrings</option>
                        <option>Mens</option>
                        <option>Anklets</option>
                        <option>Custom</option>
                      </select>

                      <input
                        type="text"
                        placeholder="SKU"
                        value={image.sku}
                        onChange={(e) =>
                          updateImageDetails(image.id, "sku", e.target.value)
                        }
                        className="w-full px-3 py-2 border rounded text-sm"
                      />
                    </div>

                    <button
                      onClick={() => removeImage(image.id)}
                      className="absolute top-2 right-2 bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-lg opacity-0 group-hover:opacity-100 transition"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>

              <div className="mt-8 text-center">
                <button
                  onClick={uploadImages}
                  className="bg-green-600 text-white px-10 py-3 rounded-lg text-lg font-medium hover:bg-green-700 transition shadow-md"
                >
                  Upload All Items
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Saved Items - Smaller Cards */}
        {savedItems.length > 0 && (
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-6 text-center">
              Your Jewelry Collection
            </h2>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
              {savedItems.map((item) => (
                <div
                  key={item._id}
                  className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition"
                >
                  <img
                    src={item.imagePath}
                    alt={item.name || "Jewelry"}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h3 className="font-semibold text-sm truncate">
                      {item.name || "Unnamed"}
                    </h3>
                    <p className="text-xl font-bold text-green-600 mt-1">
                      ${parseFloat(item.price || 0).toFixed(2)}
                    </p>
                    <p className="text-xs text-gray-600 mt-2 line-clamp-2">
                      {item.description || "No description"}
                    </p>
                    <div className="text-xs text-gray-500 mt-2">
                      <p>{item.category || "—"}</p>
                      <p>SKU: {item.sku || "—"}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;